import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {QuestionForm} from "../forms";
import {questionService} from "../../services";
import {forms} from "@atttomyx/shared-utils";
import {ANSWER_TYPE_DOUBLE, ANSWER_TYPE_INTEGER, ANSWER_TYPE_STRING} from "../../constants";

const toData = (order) => {
    return {
        ask: null,
        type: ANSWER_TYPE_STRING,
        order: order,
        min: null,
        max: null,
        valid: false,
    }
};

const AddQuestionDialog = (props) => {
    const { snackbar, questionnaireId, order, onCancel, onSave } = props;
    const [ data, setData ] = useState(toData(order));
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        setSaving(true);

        const success = (saved) => {
            snackbar.setSuccess(saved.ask + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const modified = {
            questionnaireId: questionnaireId,
            ask: data.ask,
            type: data.type,
            order: data.order,
        };

        if (data.type === ANSWER_TYPE_INTEGER || data.type === ANSWER_TYPE_DOUBLE) {
            modified.metadata = {
                min: data.min,
                max: data.max,
            };
        }

        questionService.createQuestion(modified, success, failure);
    }

    return <Dialog
        open={true}
        aria-labelledby="add-question-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add Question
        </ClosableDialogTitle>
        <DialogContent className="add-question-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <QuestionForm
                    data={data}
                    onChange={setData}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button color="primary"
                    disabled={!data.valid || !forms.differ(toData(order), data)}
                    onClick={submitForm}>
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default AddQuestionDialog;
